module.exports = __webpack_public_path__ + "media/images/icon-bw-facebook-ec1a0e6ec4d26b53f020fc3444c51f9d.png";